export default "__VITE_ASSET__Bl9y7pu$__"